"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
/** Reusable modal with Escape key support and overlay click to close. Shared by dashboard & mango-personal. */
const Modal = ({ open, onClose, title, children, maxWidth = 400, loading = false, }) => {
    (0, react_1.useEffect)(() => {
        const handleKeyDown = (e) => {
            if (e.key === 'Escape' && !loading)
                onClose();
        };
        window.addEventListener('keydown', handleKeyDown);
        return () => window.removeEventListener('keydown', handleKeyDown);
    }, [onClose, loading]);
    if (!open)
        return null;
    return ((0, jsx_runtime_1.jsx)("div", { style: {
            position: 'fixed',
            inset: 0,
            background: 'rgba(0,0,0,0.5)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 1000,
        }, onClick: () => !loading && onClose(), role: "dialog", "aria-modal": "true", "aria-labelledby": title ? 'modal-title' : undefined, children: (0, jsx_runtime_1.jsxs)("div", { style: {
                background: 'white',
                padding: 24,
                borderRadius: 12,
                maxWidth: maxWidth,
                width: '90%',
                boxShadow: '0 4px 20px rgba(0,0,0,0.2)',
            }, onClick: (e) => e.stopPropagation(), children: [title && ((0, jsx_runtime_1.jsx)("h3", { id: "modal-title", style: { margin: '0 0 16px 0', fontSize: 18 }, children: title })), children] }) }));
};
exports.default = Modal;
